import { TIPOS_INTERACCION, nombreEquipo, type CuentaDetalle } from "../../api/tipos";
import { useFormularios } from "../../shell/Formularios";
import { Abierto, CabeceraSeccion, fmtFecha } from "../../ui/primitivas";

const GLIFO: Record<string, string> = { reunion: "◉", llamada: "☏", correo: "✉", whatsapp: "◌", visita: "▣" };

export function Interacciones({ c }: { c: CuentaDetalle }) {
  const { abrir } = useFormularios();
  const items = c.interacciones;
  return (
    <div style={{ maxWidth: 760 }}>
      <CabeceraSeccion titulo="Interacciones" n={items.length} derecha={<button className="btn btn-primario" onClick={() => abrir({ tipo: "interaccion", cuentaId: c.id })}>+ Registrar interacción</button>} />
      {items.length === 0 ? (
        <Abierto>Sin interacciones registradas. La primera reunión, llamada o correo mueve la cuenta a <strong>Contactado</strong>.</Abierto>
      ) : (
        <div className="lista">
          {items.map((it) => (
            <div key={it.id} style={{ display: "grid", gridTemplateColumns: "36px minmax(0,1fr) auto", gap: 14, padding: "12px 18px", alignItems: "start" }}>
              <span style={{ width: 32, height: 32, borderRadius: 8, background: "var(--navy)", color: "#fff", display: "grid", placeItems: "center", fontSize: 13 }}>{GLIFO[it.tipo]}</span>
              <span style={{ minWidth: 0 }}>
                <span style={{ display: "flex", gap: 8, alignItems: "baseline", flexWrap: "wrap" }}>
                  <span style={{ fontWeight: 500, fontSize: 14 }}>{TIPOS_INTERACCION[it.tipo]}{it.con ? ` con ${it.con}` : ""}</span>
                  <span style={{ fontSize: 12, color: "var(--faint)" }}>{nombreEquipo(it.quien)}</span>
                </span>
                <span style={{ display: "block", fontSize: 13.5, lineHeight: 1.5, marginTop: 2 }}>{it.resumen}</span>
                {(it.proxima_accion || it.compromiso_fecha) && (
                  <span style={{ display: "block", fontSize: 12.5, color: "var(--muted)", marginTop: 4 }}>
                    → {it.proxima_accion ?? "compromiso"}{it.compromiso_fecha ? ` · para el ${fmtFecha(it.compromiso_fecha)}` : ""}
                  </span>
                )}
                {it.transcripcion && (
                  <details style={{ marginTop: 6 }}>
                    <summary style={{ cursor: "pointer", fontSize: 12.5, color: "var(--sky)" }}>
                      Transcripción{it.transcripcion_archivo ? ` · ${it.transcripcion_archivo}` : ""}
                    </summary>
                    <div style={{ marginTop: 6, maxHeight: 360, overflow: "auto", padding: "10px 12px", background: "var(--sunken)", borderRadius: 8, fontSize: 13, lineHeight: 1.55, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
                      {it.transcripcion}
                    </div>
                  </details>
                )}
              </span>
              <span className="mono" style={{ color: "var(--muted)", whiteSpace: "nowrap" }}>{fmtFecha(it.fecha, true)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
